<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6 2.678H8.576l-.256-.75C7.98 1.023 7.068.42 6.048.424H2.4C1.075.425 0 1.434 0 2.678v9.765c0 1.245 1.075 2.254 2.4 2.254h11.2c1.325 0 2.4-1.01 2.4-2.254V4.932c0-1.245-1.075-2.254-2.4-2.254z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
